import { createContext } from 'react';
import {
	IItemDishesForGetInfoV2,
	IItemForGetShortInfo,
	IItemForGetShortInfoWithStatus,
	IGetDishRestaurantProperties,
	TLanguageIDs,
	IGetDishRestaurantPortions,
} from 'types';

export type TTypeOfModalWindow =
	| null
	| 'errorUpdatingDish'
	| 'errorDishHasPortions'
	| 'assignRestaurants'
	| 'assignSuggested'
	| 'assignAdditional'
	| 'assignModifications'
	| 'assignSubcategories'
	| 'editModGroupTemplate'
	| 'assignPortionsRestaurants'
	| 'createPortion'
	| 'viewPortion'
	| 'editPortion'
	| 'toConfirmDeletePortion'
	| 'errorDeletingPortion'
	| 'successDeletingPortion';

export interface IViewDishState {
	needRefetchData: boolean;
	needRefetchRestPropsData: boolean;
	needRefetchRestaurantPortionsData: boolean;
	dishFullInfo: Nullable<IItemDishesForGetInfoV2>;
	selectedTranslationTab: Nullable<TLanguageIDs>;
	accessibleRestaurants: IItemForGetShortInfoWithStatus[];
	accessiblePortionsRestaurants: IItemForGetShortInfo[];
	restaurantIdForRestaurantProps: Nullable<string>;
	restaurantProps: Nullable<IGetDishRestaurantProperties['data']>;
	restaurantIdForPortions: Nullable<string>;
	restaurantPortions: Nullable<IGetDishRestaurantPortions['data']>;
	selectedPortionId: string;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const viewDishInitialState: IViewDishState = {
	needRefetchData: false,
	needRefetchRestPropsData: false,
	needRefetchRestaurantPortionsData: false,
	dishFullInfo: null,
	selectedTranslationTab: null,
	accessibleRestaurants: [],
	accessiblePortionsRestaurants: [],
	restaurantIdForRestaurantProps: null,
	restaurantProps: null,
	restaurantIdForPortions: null,
	restaurantPortions: null,
	selectedPortionId: '',
	typeOfModalWindow: null,
};

export interface IViewDishContext extends IViewDishState {
	refetchData(value: boolean): void;
	setTranslationTab(value: Nullable<TLanguageIDs>): void;
	setRestaurantIdForRestaurantProps(value: Nullable<string>): void;
	refetchRestPropsData(value: boolean): void;
	setRestaurantIdForPortions(value: Nullable<string>): void;
	refetchRestaurantPortionsData(value: boolean): void;
	changeSelectedPortionId(value: string): void;
	deleteSelectedPortion(): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
}

export const ViewDishContext = createContext<IViewDishContext>({
	refetchData: () => undefined,
	setTranslationTab: () => undefined,
	setRestaurantIdForRestaurantProps: () => undefined,
	refetchRestPropsData: () => undefined,
	setRestaurantIdForPortions: () => undefined,
	refetchRestaurantPortionsData: () => undefined,
	changeSelectedPortionId: () => undefined,
	deleteSelectedPortion: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	...viewDishInitialState,
});
